import { Change } from '../comun/recipient-services/change';
import { ComponentModifyShipping } from './component-modify-shipping';
import { ChangeType } from '../enums/change-type.enum';
import { NgForm } from '@angular/forms';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ConfirmChangeModalComponent } from './confirm-change-modal/confirm-change-modal.component';
import { ViewContainerRef, ChangeDetectorRef, Directive } from '@angular/core';
import { ConfirmSolutionModalComponent } from './confirm-solution-modal/confirm-solution-modal.component';
import { IGoogleAnalitycsAware } from '../google-analitycs-aware';
import { CategoriasGoogleAnalytics } from '../services/sesion.service';

@Directive()
export abstract class ChangeComponent extends ComponentModifyShipping implements IGoogleAnalitycsAware {
  abstract change: Change;
  constructor(private modalService: BsModalService, private vcr: ViewContainerRef) {
    super();
  }
  get active(): boolean {
    return this.sesion.tipoCambioActivo === ChangeType.DeliveryDay;
  }

  confirm(frm: NgForm) {
    if (frm.invalid) {
      return;
    }

    let componente: any;
    if (this.expedition.ProductType === 'B2C') {
      componente = ConfirmChangeModalComponent;
    } else {
      componente = ConfirmSolutionModalComponent;
    }

    const modal = this.modalService.show(componente, {
      initialState: {
        change: this.change,
        cdrPadre: this.vcr.parentInjector.get(ChangeDetectorRef)
      }
    });
  }
  private enviadoCambio = false;

  changed() {
    if (!this.enviadoCambio) {
      const nombreTipo = (<Map<number, string>>(<any>ChangeType).nombres).get(this.change.type);
      this.enviadoCambio = true;
      this.sesion.enviarEventoGoogleAnalitics(CategoriasGoogleAnalytics.ExpeditionModification, 'Cambio Valores', nombreTipo);
    }
  }
}
